{
  "version": "0.2.11",
  "extensionId": "objhnmnodmnmjiegkddnfgbjbhfohokm",
  "sha256": "c97214fe4767fab7299492b6257c46a0c764651705a893692fe0e599d02e58f5",
  "bytes": 81741,
  "download": "https://gab.ai/browser-extension/gab-ai-browser-extension-preview.zip",
  "channel": "manual-preview",
  "chatOrigin": "https://gab.ai"
}
